await import(`@liferay/language/${Liferay.ThemeDisplay.getLanguageId()}/frontend-data-set-web/all.js`);
/**
 * SPDX-FileCopyrightText: (c) 2000 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

export const AUTOCOMPLETE_VALUE_UPDATED = 'autocomplete-updated';
export const CLOSE_MODAL = 'close-modal';
export const CLOSE_SIDE_PANEL = 'close-side-panel';
export const CURRENT_PRODUCT_STATUS_CHANGED = 'current-product-status-changed';
export const CURRENT_PRODUCT_UPDATED = 'current-product-updated';
export const IFRAME_LOADED = 'iframe-loaded';
export const IS_LOADING_MODAL = 'is-loading-modal';
export const OPEN_MODAL = 'open-modal';
export const OPEN_MODAL_FROM_IFRAME = 'open-modal-from-iframe';
export const OPEN_SIDE_PANEL = 'open-side-panel';
export const PRODUCT_OPTIONS_CHANGED = 'product-options-changed';
export const SIDE_PANEL_CLOSED = 'side-panel-closed';

const EVENTS = {
	ACTION_PERFORMED: 'fds-action-performed',
	AUTOCOMPLETE_VALUE_UPDATED,
	CLOSE_MODAL,
	CLOSE_SIDE_PANEL,
	CURRENT_PRODUCT_STATUS_CHANGED,
	CURRENT_PRODUCT_UPDATED,
	DISPLAY_UPDATED: 'fds-display-updated',
	IFRAME_LOADED,
	IS_LOADING_MODAL,
	OPEN_MODAL,
	OPEN_MODAL_FROM_IFRAME,
	OPEN_SIDE_PANEL,
	PRODUCT_OPTIONS_CHANGED,
	SIDE_PANEL_CLOSED,
	UPDATE_DISPLAY: 'fds-update-display',
};

export default EVENTS;
